import { FC } from 'react';
import spriteUrl from './sprite/sprite.svg';
import { IconName } from './sprite/icon-types';

interface SpriteFlagDisplayProps {
  flag: IconName;
}

export const SpriteFlagDisplay: FC<SpriteFlagDisplayProps> = ({ flag }) => {
  return (
    <svg
      width="32"
      height="24"
      className="w-[34px] h-[24px]"
      filter="url(#outlineFilter)"
      viewBox="0 0 32 24"
      overflow="visible">
      <defs>
        <filter id="outlineFilter">
          <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="thicken" />
          <feFlood floodColor="rgba(0, 0, 0, 0.1)" result="glowColor" />
          <feComposite in="glowColor" in2="thicken" operator="in" result="softGlowColored" />
          <feMerge>
            <feMergeNode in="softGlowColored" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <use href={`${spriteUrl}#${flag}`} />
    </svg>
  );
};
